export default class StockAlert {
  constructor() {
    this.DOM = {};
    this.DOM.view = document.querySelector("stock-alert");
    this.DOM = {
      btn: this.DOM.view.querySelector(".js-submit"),
      input: this.DOM.view.querySelector("input"),
      form: this.DOM.view.querySelector(".js-form"),
      success: this.DOM.view.querySelector(".js-success"),
    };
    this.VARS = {
      API_PUBLIC_KEY: "TTryif",
    };
    this.events();
  }

  createSub() {
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: this.DOM.input.value,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${
                document.getElementById("jsVariantId").value
              }`,
            },
          },
        },
      },
    };
    var requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: "2023-09-15" },
      body: JSON.stringify(payload),
    };

    fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.VARS.API_PUBLIC_KEY}`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 202) {
          this.DOM.success.style.display = "block";
          this.DOM.form.style.display = "none";
        }
        console.log(response);
      })
      .catch((err) => console.log(err));
  }

  events() {
    this.DOM.btn.addEventListener("click", () => {
      this.createSub();
      // console.log(document.getElementById("jsVariantId"), this.DOM.input.value);
    });
  }
}
